import { render } from "./AanmeldingUitgebreid.vue?vue&type=template&id=484bb809&scoped=true"
import script from "./AanmeldingUitgebreid.vue?vue&type=script&lang=js"
export * from "./AanmeldingUitgebreid.vue?vue&type=script&lang=js"

import "./AanmeldingUitgebreid.vue?vue&type=style&index=0&id=484bb809&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484bb809"]])

export default __exports__